import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mercedes-loader',
  templateUrl: './mercedes-loader.component.html',
  styleUrls: ['./mercedes-loader.component.scss']
})
export class MercedesLoaderComponent implements OnInit {

  constructor() { }
  ngOnInit(): void {
  }

}
